import {
  ActionTypes,
  ShowMessageNavigationDialogPayload,
} from './actions'

export type MessageNavigationDialogState = {
  open: boolean
} & ShowMessageNavigationDialogPayload

const initialState: MessageNavigationDialogState = {
  open: false,
  message: '',
  variant: 'error',
  path: '',
  actionTitle: '',
}

export const messageNavigationDialog = (
  state: MessageNavigationDialogState = initialState,
  action: {
    type: string
    payload?: ShowMessageNavigationDialogPayload
  }
): MessageNavigationDialogState => {
  switch (action.type) {
    case ActionTypes.SHOW_MESSAGE_NAVIGATION_DIALOG:
      return {
        ...state,
        open: true,
        ...(action.payload as ShowMessageNavigationDialogPayload),
      }
    case ActionTypes.HIDE_MESSAGE_NAVIGATION_DIALOG:
      return { ...initialState }
    default:
      return state
  }
}
